module.exports = __webpack_public_path__ + "img/dumas_fils.06fbc4e6.jpg";